import styled from "styled-components";

export const Container = styled.div`
  width: 60px;
  min-width: 60px;
  height: 100vh;
  background-color: var(--gray-color);
  overflow-y: auto;
  border-left:1px solid var(--border-color);
  z-index: 12;
`;

export const LogoIconContainer = styled.div`
  margin: .75rem 0;
  padding-bottom: .37rem;
  color: var(--default-text-color);
  text-align: center;
  border-bottom: 1px solid var(--border-color);
  width: 100%;
`;

export const LogoIcon = styled.i`
  &::before {
    font-size: 20px;
  }
`;

export const IconContainer = styled.div`
  flex: 1;
  margin-top: 1.5rem;
`;

export const Icon = styled.i`
  transition: .2s;
  color: ${props => props.active ? `var(--accent-color)` : 'var(--muted-color)'};
  
  &::before {
    font-size: 20px;
  }
`;
